import React from 'react'
import Carousal from './carousal'
import Services from './services'
import Contractors from './services copy'
import CarousalTwo from './carousal copy'
import WhatWeDo from './services copy 2'
import FeaturedWork from './services copy 3'
import RecentNews from './services copy 4'
import FinalRow from './services copy 5'
import { useContext } from 'react'
import NoteContext from '../context/notes/noteContext'
export default function Home() {
    const context = useContext(NoteContext)
    const {backgroundColor,setBackgroundColor,setBars} = context
    setBars('grey-bars')
    setBackgroundColor('black')
    return(
        <div>
            <Carousal/>
            <Services/>
            <Contractors/>
            <CarousalTwo/>
            <WhatWeDo/>
            <FeaturedWork/>
            <RecentNews/>
            <FinalRow/>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/home.jsx